import '../../scss/pages/product-list.scss';
import 'swiper/dist/css/swiper.css';

import Swiper from 'swiper';
import {AlcoholBox} from '../libraries/alcohol-box';
import {ProductListItem} from "../libraries/product-list/ProductListItem";
import {CustomerFeedback} from "../libraries/customer-feedback/CustomerFeedback";

function setupProductsToGoogle() {

    let productList = [];
    let product = {};

    const dataProduct = document.querySelectorAll('[data-product]');

    dataProduct.forEach( (element, key) => {

        const productId = element.getAttribute('data-product-id');
        const productName = element.getAttribute('data-product-name');
        const productSku = element.getAttribute('data-product-sku');
        const productCategory = element.getAttribute('data-product-category');
        const productBrand = element.getAttribute('data-product-brand');
        const productPrice = element.getAttribute('data-product-price');
        const productUrl = element.getAttribute('data-product-url');

        product[productSku] = {
            'id': productSku,
            'name': productName,
            'category': productCategory,
            'brand': productBrand,
            'price': productPrice,
            'isbn': productSku,
            'position': key + 1
        };

        productList.push(product[productSku]);

        element.addEventListener('click', function(event){
            productData['position'] = key;
            if (typeof ga4SendEvent == 'function') {
                ga4SendEvent('select_item',product[productSku]);
            }

            if (typeof removeCookie == 'function') {
                removeCookie('product');
            }
            if (typeof setCookie == 'function') {
                let data = window.btoa(unescape(encodeURIComponent(JSON.stringify(productData))));
                setCookie('product', data, 21);
            }
        });

        const addToCart = element.querySelector('.product-add-to-cart');
        if (null !== addToCart) {
            addToCart.addEventListener('click', function(event){
                productData['position'] = key;
                if (typeof ga4SendEvent == 'function') {
                    ga4SendEvent('add_to_cart',product[productSku]);
                }

                if (typeof removeCookie == 'function') {
                    removeCookie('product');
                }
                if (typeof setCookie == 'function') {
                    let data = window.btoa(unescape(encodeURIComponent(JSON.stringify(productData))));
                    setCookie('product', data, 21);
                }
                if (typeof tiktok_addToCart == 'function') {
                    tiktok_addToCart(product[productSku]);
                }

                document.location.href='koszyk.php?a=add&pr='+productId+'&qty=1';
            });
        }
    });

    ga4SendEvent('view_item_list',productList);
}

function initializeProductItems() {
    const elements = document.querySelectorAll('.products-list-item');
    for (let element of elements) {
        new ProductListItem(element);
    }
}

function handleShowMoreContent() {
    const button = document.querySelector('.top-description-show-more');

    if (!button) {
        return
    }

    button.addEventListener('click', () => {
       const content = document.querySelector('.top-description');

       if (!content) {
           return;
       }

        content.style.height = 'auto';
        button.remove();
    });
}

const Carousels = {
    subcategoriesSlider: null,

    init() {
        const subcategoriesSliderSelector = '#subcategory-mobile .subcategories-slider.swiper-container';
        Carousels.subcategoriesSlider = new Swiper(subcategoriesSliderSelector, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            noSwiping: true,
            noSwipingClass: 'swiper-no-swiping',
            scrollbar: {
                el: '#subcategory-mobile .swiper-scrollbar',
                hide: false,
            },
        });
    }
};

function initialize() {
    initializeProductItems();

    setupProductsToGoogle();

    new CustomerFeedback();
    const alcoholBox = new AlcoholBox();
    alcoholBox.showSiteMessage();

    handleShowMoreContent();
    Carousels.init();
}

document.addEventListener('DOMContentLoaded', initialize);
